import { required, helpers, minLength, maxLength } from '@vuelidate/validators';
import { computed } from 'vue';
import { isValidTel, isValidForeignAddress } from './common';

export function getUpdateUserRules(t, userStore) {
    return computed(() => {
        return {
            zip_code: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                maxLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MAX_LENGTH', { max: $params.max }),
                    maxLength(7)
                )
            },
            tel: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                minLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MIN_LENGTH', { min: $params.min }),
                    minLength(10)
                ),
                maxLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MAX_LENGTH', { max: $params.max }),
                    maxLength(20)
                ),
                isValidTel: helpers.withMessage(t('ERROR_TEL_INPUT_INVALID'), isValidTel),
            },

            address_2: userStore.isOverseasUser ? {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                isValidForeignAddress: helpers.withMessage(
                    t('ERROR_ADDRESS_INVALID'),
                    isValidForeignAddress
                ),
            } : { required: helpers.withMessage(t('ERROR_REQUIRED'), required) },

            address_3: userStore.isOverseasUser ? {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                isValidForeignAddress: helpers.withMessage(
                    t('ERROR_ADDRESS_INVALID'),
                    isValidForeignAddress
                ),
            } : { required: helpers.withMessage(t('ERROR_REQUIRED'), required) },
        }
    })
}